import sdk from '@/sdk';
import * as localStorage from '@/utils/storageUtils';


const LOCAL_KEY = 'grayRelease_cache_';


const setData = (value: any) => {
    const key = `${LOCAL_KEY}${sdk.as.user?.userGuid || ''}`;
    localStorage.set(key, value);

};

const getData = () => {
    const key = `${LOCAL_KEY}${sdk.as.user?.userGuid || ''}`;
    const data = localStorage.get(key);
    if (!data) {
        return null;
    }
    return data;
};

export default function createCacheFetch<T>(originFetch: (data: any) => Promise<T>) {
    return (data: any) => {
        return new Promise((rs, rj) => {
            originFetch(data).then((res) => {
                setData(res);
                rs(res);
            }).catch(() => {
                const data = getData();
                if (data) {
                    rs(data);
                } else {
                    rj();
                }
            });
        });
    };
}
